var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCompressPdf = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.265625,
    width: 64,
    height: 64,
    rx: 12,
    fill: "#FFC1C1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9648 34.3H20.3648M29.9648 34.3V43.9M29.9648 34.3L18.7648 45.5",
    stroke: "#1D1D1D",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5656 28.9492H45.1656M35.5656 28.9492V19.3492M35.5656 28.9492L46.7656 17.7492",
    stroke: "#1D1D1D",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCompressPdf);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/compressPdf.f3655dc6799e6e6e4849d2f001536bfb.svg";